import { CommonResponse } from 'models/common';
import axiosClient from 'utils/axiosClient';
import { MenuClassification, MenuCsv, MenuDetail, SearchMenuFilter } from './models/menu';

const menuService = {
  getMenuDetailList(data: SearchMenuFilter): Promise<CommonResponse<Array<MenuDetail>>> {
    const url = `/menu-details`;
    return axiosClient.post(url, data);
  },
  deleteMenu(data: Array<number>): Promise<CommonResponse<null>> {
    const url = `/delete-menu`;
    return axiosClient.patch(url, data);
  },
  getMenuClassification(): Promise<CommonResponse<Array<MenuClassification>>> {
    const url = `/menu-classification`;
    return axiosClient.get(url);
  },
  postMenuList(data: Array<MenuCsv>): Promise<CommonResponse<null>> {
    const url = `/import-menu`;
    return axiosClient.post(url, data);
  },
  getMenuImportCsvTemplate(): Promise<Blob> {
    const url = `/get-csv-template`;
    return axiosClient.get(url, { responseType: 'blob' });
  },
  restoreMenu(data: number): Promise<CommonResponse<null>> {
    const url = `/restore-menu`;
    return axiosClient.patch(url, data);
  },
  getOrderLimit(): Promise<CommonResponse<{ key: string; value: string }[]>> {
    const url = `/orders-limit`;
    return axiosClient.get(url);
  },
};

export default menuService;
